<template>
  <v-container fluid>
    <v-alert type="warning">
      Please, choose carefully. This can not be changed later.
    </v-alert>

    <v-row>
      <v-col>
        <p>
          Which party would you like to set at the Record Holder?
        </p>

        <v-radio-group
          v-model="recordHolderPartyIdentifier"
          mandatory
          @change="_ => setRecordHolderParty()"
        >
          <v-radio
            v-for="party of edited.parties"
            :key="party.identifier"
            :label="`${party.first_name} ${party.last_name}`"
            :value="party.identifier"
          />
        </v-radio-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

import { RECORD_NAMESPACE } from '@/store/record'

export default {
  name: 'RecordEditorRecordHolderPartySelect',

  data () {
    return {
      previousRecordHolderPartyIdentifier: null,
      recordHolderPartyIdentifier: null,
    }
  },

  computed: {

    ...mapGetters(RECORD_NAMESPACE, [
      'edited',
    ]),
  },

  methods: {
    setRecordHolderParty () {
      if ([null, undefined].includes(this.recordHolderPartyIdentifier)) return

      this.updateRecordHolderParty(this.recordHolderPartyIdentifier, true)
      this.updateRecordHolderParty(this.previousRecordHolderPartyIdentifier, false)

      this.previousRecordHolderPartyIdentifier = this.recordHolderPartyIdentifier
    },

    updateRecordHolderParty (identifier, isRecordHolder) {
      if (identifier === null) return

      const partyIndex = this.edited.parties.findIndex(caseParty => caseParty.identifier === identifier)
      const party = this.edited.parties[partyIndex]
      if (party === undefined) return

      party.is_record_holder = isRecordHolder

      Vue.set(this.edited.parties, partyIndex, party)
    },
  },
}
</script>
